import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";

/**
 *
 * @param {any[]} receiptDetailedBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  receiptDetailedBalance,
  selectedStore,
  startDate,
  endDate
) => {
  const excelData = [];
  let totalIncome = 0;
  for (let item = 0; item < receiptDetailedBalance.length; item++) {
    const balance = receiptDetailedBalance[item];
    excelData.push({
      order: item + 1,
      customer: `${balance.Customer.name} ${balance.Customer.lastname}`,
      receiptType: balance.receipt_type,
      totalNet: balance.total_net,
    });
    totalIncome += balance.total_net;
  }
  excelData.push({
    order: "",
    customer: "TOTAL",
    receiptType: "",
    totalNet: totalIncome,
  });
  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR RECIBO DETALLADO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "receiptType",
            outValue: "TIPO DE COMPROBANTE",
          },
          {
            inValue: "totalNet",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-general-por-tipo-de-comprobante_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-por-tipo-de-comprobante_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};

/**
 *
 * @param {any[]} receiptBalance
 * @returns {Workbook}
 */
export const exportExcelGeneral = async (
  receiptBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalQuantity = 0;
  let totalIncome = 0;

  const excelData = [];

  for (let item = 0; item < receiptBalance.length; item++) {
    const balance = receiptBalance[item];

    excelData.push({
      order: item + 1,
      name: balance.receipt_type,
      quantity: balance.quantity,
      total: balance.total,
    });

    totalQuantity += balance.quantity;
    totalIncome += balance.total;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR RECIBO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "TIPO DE COMPROBANTE",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileNameGeneral(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileNameGeneral = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-tipo-de-comprobante_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-tipo-de-comprobante_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ReceiptBalance/excel.js